module.exports = __webpack_public_path__ + "static/media/start_assessment.13685556.png";